var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgAvatar = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: 20,
    height: 20,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176 448c-8.7 0-16 7.3-16 16v48h32v-48c0-8.7-7.2-16-16-16zm96 0c-8.75 0-16 7.25-16 16s7.25 16 16 16 16-7.25 16-16-7.2-16-16-16zM164 172l8.205 24.62c1.215 3.645 6.375 3.645 7.59 0L188 172l24.62-8.203c3.646-1.219 3.646-6.375 0-7.594L188 148l-8.2-24.6c-1.215-3.648-6.375-3.648-7.59 0L164 148l-24.6 8.2c-3.646 1.219-3.646 6.375 0 7.594L164 172zm172.1 143.4C304 338.6 265.1 352 224 352s-80.03-13.43-112.1-36.59C46.55 340.2 0 403.3 0 477.3 0 496.5 15.52 512 34.66 512H128v-64c0-17.75 14.25-32 32-32h128c17.75 0 32 14.25 32 32v64h93.34c19.16 0 34.66-15.5 34.66-34.7 0-74-46.5-137.1-111.9-161.9zM64 224h13.5c24.8 56.5 80.9 96 146.5 96s121.8-39.5 146.5-96H384c8.75 0 16-7.25 16-16v-96c0-8.7-7.2-16-16-16h-13.5C345.8 39.5 289.6 0 224 0S102.3 39.5 77.5 96H64c-8.75 0-16 7.3-16 16v96c0 8.8 7.25 16 16 16zm40-88c0-22.1 21.5-40 48-40h144c26.5 0 48 17.88 48 40v24c0 53-43 96-96 96h-48c-53 0-96-43-96-96v-24z"
  })));
};

export { SvgAvatar as ReactComponent };